module.exports = __webpack_public_path__ + "img/goods1.4d630e6a.png";